<template>
  <div class="d-flex gap-2 flex-wrap w-100 justify-content-center">
    <button class="btn btn-warning" @click="$emit('hold')">
      <i class="fe fe-clock me-1"></i> Attente
    </button>

    <button class="btn btn-outline-dark" @click="$emit('void')">
      <i class="fe fe-x-circle me-1"></i> Annuler
    </button>

    <button class="btn btn-success" @click="$emit('checkout')" :disabled="isSubmitting">
      <i v-if="isSubmitting" class="fe fe-loader spinner-border spinner-border-sm me-1"></i>
      <i v-else class="fe fe-check-circle me-1"></i> Paiement
    </button>

    <button class="btn btn-secondary" @click="$emit('transactions')">
      <i class="fe fe-list me-1"></i> Transactions
    </button>

    <button class="btn btn-danger" @click="$emit('reset')">
      <i class="fe fe-trash-2 me-1"></i> Vider
    </button>
  </div>
</template>

<script>
  export default {
    name: "OrderFooterActions",
    props: {
      isSubmitting: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
